<template>
    <v-app>
        <v-main class="main">

            <!-- Sidebar -->
            <Sidebar :drawerOpen="drawerOpen" :collapsed="isSidebarCollapsed" :isMobile="isMobile"
                @update:drawerOpen="drawerOpen = $event" />

            <v-container fluid class="main-content pa-4">

                <!-- Header -->
                <Header :isDarkMode="isDarkMode" :isMobile="isMobile" @toggle-sidebar="toggleSidebar" />

                <div class="content">

                    <!-- FILTER ROW -->


                    <v-row class="g-4 mt-4 mb-8" dense>

                        <!-- Details -->
                        <v-col cols="12" md="12" class="ps-md-3">
                            <div class="column-title mb-6">
                                <h5 class="m-0 text-left">Opportunity Details</h5>
                                <hr class="title-separator" />
                            </div>


                            <v-card class="outer-card chart-wrapper" style="border-radius: 8px;" flat>
                                <v-row>
                                    <v-col cols="12" class="d-flex justify-start mb-4">
                                        <v-btn variant="text" prepend-icon="mdi-chevron-left" @click="$router.back()">
                                            Back
                                        </v-btn>
                                    </v-col>
                                </v-row>
                                <hr class="title-separator" />
                                <v-card class="pa-3 inner-transaction-card" flat>
                                    <!-- <div class="mb-2">
                                        <h5 class="m-0 text-left">Portfolio Overview</h5>
                                    </div> -->
                                    <div class="d-flex align-center gap-2 mb-4">
                                        <img :src="product.product_image ? `${STORAGE_URL}/${product.product_image}` : defaultImage"
                                            class="product-image" />
                                        <div class="text-left">
                                            <div class="font-weight-bold text-body-1">
                                                {{ product.product_name }}
                                            </div>
                                            <div class="text-caption text-grey">
                                                {{ product?.partner?.name }}
                                            </div>
                                        </div>
                                    </div>
                                    <v-card class="outer-card" flat>
                                        <v-row dense class="g-2" style="height: 100%; padding: 16px;">

                                            <!-- FULL WIDTH COLUMN -->
                                            <v-col cols="12">

                                                <!-- INNER ROW (THIS FIXES YOUR ISSUE) -->
                                                <v-row dense>

                                                    <!-- LEFT COLUMN -->
                                                    <v-col cols="12" md="6" class="">

                                                        <!-- TOP CARD -->
                                                        <v-card class="flex-grow-1" flat>
                                                            <div class="pa-1">

                                                                <Panel toggleable v-model:collapsed="kinCollapsed">
                                                                    <template #header>
                                                                        <div class="flex items-center gap-2">
                                                                            <Button icon="pi pi-receipt"
                                                                                severity="secondary" rounded text
                                                                                style="color: green; font-size: 1.5rem;" />
                                                                            <span class="font-bold">Description</span>
                                                                        </div>
                                                                    </template>

                                                                    <template #icons>
                                                                        <Menu ref="menu" id="config_menu" :model="items"
                                                                            popup />
                                                                    </template>
                                                                        <div class="product-desc" v-html="product.description"></div>
                                                                </Panel>
                                                            </div>
                                                        </v-card>

                                                        <!-- BOTTOM CARD -->
                                                        <v-card class="flex-grow-1" flat>
                                                            <div class="pa-1 justify-space-between">
                                                                <Panel toggleable v-model:collapsed="termCollapsed">
                                                                    <template #header>
                                                                        <div class="flex items-center gap-2">
                                                                            <Button icon="pi pi-receipt"
                                                                                severity="secondary" rounded text
                                                                                style="color: green; font-size: 1.5rem;" />
                                                                            <span class="font-bold">Investment
                                                                                Note</span>
                                                                        </div>
                                                                    </template>

                                                                    <template #icons>
                                                                        <Menu ref="menu" id="config_menu" :model="items"
                                                                            popup />
                                                                    </template>
                                                                        <div class="product-desc" v-html="product.description"></div>
                                                                </Panel>
                                                            </div>
                                                        </v-card>

                                                    </v-col>

                                                    <!-- RIGHT COLUMN -->
                                                    <v-col cols="12" md="6" class="d-flex">

                                                        <v-card class="inner-card flex-grow-1 pa-3" flat>
                                                            <!-- ITEM 1 -->
                                                            <div
                                                                class="d-flex justify-space-between align-center py-3 mb-4">
                                                                <span class="text-body-2 font-weight-medium">
                                                                    Interest Rate
                                                                </span>

                                                                <span class="text-body-2 font-weight-semibold">
                                                                    {{ formatNumber(product.interest) }}%
                                                                </span>
                                                            </div>

                                                            <v-divider />

                                                            <!-- ITEM 2 -->
                                                            <div
                                                                class="d-flex justify-space-between align-center py-3 mb-4">
                                                                <span class="text-body-2 font-weight-medium">
                                                                    Maturity Date
                                                                </span>

                                                                <span class="text-body-2 font-weight-semibold">
                                                                    {{ formatDate(product.maturity_date) }}
                                                                </span>
                                                            </div>

                                                            <v-divider />

                                                            <!-- ITEM 2 -->
                                                            <div
                                                                class="d-flex justify-space-between align-center py-3 mb-4">
                                                                <span class="text-body-2 font-weight-medium">
                                                                    Available Volume
                                                                </span>

                                                                <span class="text-body-2 font-weight-semibold">
                                                                    {{ formatNumber(product.available_volume) }}
                                                                </span>
                                                            </div>



                                                            <!-- ITEM 2 -->
                                                            <div
                                                                class="d-flex justify-space-between align-center py-3 mb-4">
                                                                <span class="text-body-2 font-weight-medium">
                                                                    Days to Maturity
                                                                </span>

                                                                <span class="text-body-2 font-weight-semibold">
                                                                    {{ daysToMaturity }}
                                                                </span>
                                                            </div>

                                                            <v-divider />
                                                            <!-- INNER CARD -->
                                                            <form @submit.prevent="handleInvest"
                                                                class="w-full space-y-6">
                                                                <v-card class="inner-mini-card pa-4 mb-6" flat>
                                                                    <v-row>
                                                                        <v-col cols="12" md="6">
                                                                            <div class="field">

                                                                                <!-- Main Label -->
                                                                                <label
                                                                                    class="text-sm font-medium text-gray-700 d-block text-left">
                                                                                    How much would you like to invest?
                                                                                </label>

                                                                                <!-- Input -->
                                                                                <input v-model.number="amount"
                                                                                    type="number"
                                                                                    class="modern-input" />

                                                                                <!-- Helper text -->
                                                                                <label
                                                                                    class="text-caption d-block text-left mt-1">
                                                                                    Minimum of ₦10,000.00
                                                                                </label>

                                                                            </div>
                                                                        </v-col>
                                                                    </v-row>
                                                                </v-card>

                                                                <!-- INVESTMENT SUMMARY -->
                                                                <v-card v-if="showSummary"
                                                                    class="inner-mini-card pa-4 mb-6" flat>

                                                                    <div class="d-flex flex-column">

                                                                        <!-- Principal -->
                                                                        <div class="d-flex justify-space-between py-2">
                                                                            <span>Principal</span>
                                                                            <span>₦{{ formatNumber(amount) }}</span>
                                                                        </div>

                                                                        <v-divider />

                                                                        <!-- Transaction Fee -->
                                                                        <div class="d-flex justify-space-between py-2">
                                                                            <span>Transaction Fee</span>
                                                                            <span>₦{{ formatNumber(transactionFee)
                                                                            }}</span>
                                                                        </div>

                                                                        <v-divider />

                                                                        <!-- Total Pay -->
                                                                        <div class="d-flex justify-space-between py-2">
                                                                            <span>Total to Deduct
                                                                                <v-tooltip location="top">
                                                                                <template #activator="{ props }">
                                                                                    <v-icon v-bind="props" size="16"
                                                                                        class="ms-1">
                                                                                        mdi-information-variant-circle
                                                                                    </v-icon>
                                                                                </template>

                                                                                <span>{{ tooltipText.investment }}</span>
                                                                            </v-tooltip>
                                                                            </span>
                                                                            <span>₦{{ formatNumber(totalPay) }}</span>
                                                                        </div>

                                                                        <v-divider />

                                                                        <!-- Tax -->
                                                                        <!-- <div class="d-flex justify-space-between py-2">
                                                                            <span>Tax
                                                                                <v-tooltip location="top">
                                                                                <template #activator="{ props }">
                                                                                    <v-icon v-bind="props" size="16"
                                                                                        class="ms-1">
                                                                                        mdi-information-variant-circle
                                                                                    </v-icon>
                                                                                </template>

                                                                                <span>{{ tooltipText.tax_on_interest }}</span>
                                                                            </v-tooltip>
                                                                            </span>
                                                                            <span>{{ formatNumber(tax) }} %</span>
                                                                        </div> -->

                                                                        <v-divider />

                                                                        <!-- Daily Earnings -->
                                                                        <div class="d-flex justify-space-between py-2">
                                                                            <span>Daily Earnings</span>
                                                                            <span>₦{{ formatNumber(dailyRate) }}</span>
                                                                        </div>

                                                                        <v-divider />

                                                                        <!-- Tax on Interest -->
                                                                        <div class="d-flex justify-space-between py-2">
                                                                            <span>Interest Payout
                                                                                <v-tooltip location="top">
                                                                                <template #activator="{ props }">
                                                                                    <v-icon v-bind="props" size="16"
                                                                                        class="ms-1">
                                                                                        mdi-information-variant-circle
                                                                                    </v-icon>
                                                                                </template>

                                                                                <span>{{ tooltipText.final_interest }}</span>
                                                                            </v-tooltip>
                                                                            </span>
                                                                            <span>₦{{ formatNumber(interestToPay) }}</span>
                                                                        </div>

                                                                        <v-divider />

                                                                        <!-- Estimated Payout -->
                                                                        <div class="d-flex justify-space-between py-2">
                                                                            <span>Estimated Payout
                                                                                <v-tooltip location="top">
                                                                                <template #activator="{ props }">
                                                                                    <v-icon v-bind="props" size="16"
                                                                                        class="ms-1">
                                                                                        mdi-information-variant-circle
                                                                                    </v-icon>
                                                                                </template>

                                                                                <span>{{ tooltipText.returns }}</span>
                                                                            </v-tooltip>
                                                                            </span>
                                                                            <span class="text-green font-weight-bold">
                                                                                ₦{{ formatNumber(expectedPayout) }}
                                                                            </span>
                                                                        </div>

                                                                    </div>

                                                                </v-card>

                                                                <!-- HINT BEFORE 10000 -->
                                                                <p v-else-if="amount && amount < 5000"
                                                                    class="text-caption text-primary mt-2 mb-2">
                                                                    Enter at least ₦10,000 to view investment breakdown
                                                                </p>

                                                                <!-- <v-progress-linear
                                                                :model-value="amount"
                                                                :max="product.available_volume"
                                                                height="6"
                                                                /> -->

                                                                <!-- ERROR -->
                                                                <p v-if="touched.agree && !form.agree"
                                                                    class="text-red text-caption mt-1">
                                                                    You must agree to the terms
                                                                </p>

                                                                <!-- AGREEMENT -->
                                                                <div class="d-flex align-center mt-2 mb-6">

                                                                    <!-- iOS Toggle -->
                                                                    <button type="button" @click="toggleAgree"
                                                                        class="ios-toggle px-6"
                                                                        :class="{ active: form.agree }">
                                                                        <span class="ios-toggle-knob"></span>
                                                                    </button>
                                                                    <span class="text-body-2 text-grey">
                                                                        I have read, understood and agreed to the
                                                                        <a href="/terms"
                                                                            class="text-primary text-decoration-underline">
                                                                            Investment Terms
                                                                        </a>
                                                                    </span>


                                                                </div>

                                                                <!-- BUTTON -->
                                                                <button type="submit"
                                                                    :disabled="loading || !form.agree || !amount || amount < 10000"
                                                                    class="theme-button mb-4">
                                                                    <span v-if="!loading">
                                                                        Continue
                                                                        <v-icon start>mdi-arrow-right</v-icon>
                                                                    </span>

                                                                    <span v-else>
                                                                        Processing…
                                                                        <v-icon start class="spin">mdi-loading</v-icon>
                                                                    </span>
                                                                </button>
                                                            </form>
                                                        </v-card>
                                                        <v-snackbar v-model="snackbar.show" :color="snackbar.color"
                                                            timeout="3000" location="top right"> {{ snackbar.message
                                                            }}
                                                            <template #actions>
                                                                <v-btn variant="text" @click="snackbar.show = false">
                                                                    Close
                                                                </v-btn>
                                                            </template>
                                                        </v-snackbar>
                                                    </v-col>

                                                </v-row>

                                            </v-col>

                                        </v-row>
                                    </v-card>


                                </v-card>

                            </v-card>


                        </v-col>
                    </v-row>

                </div>
            </v-container>
        </v-main>
    </v-app>
</template>

<script setup>
import { ref, onMounted, onUnmounted, computed, reactive, watch } from "vue"
import Sidebar from "@/components/Sidebar.vue"
import Header from "@/components/Header.vue"
import { useInvStore } from "@/store/investment"
import { STORAGE_URL } from "@/api/env"
import { useRoute } from "vue-router"
import avatarImage from '@/assets/crowdital-icon.png'
import { formatDate, formatNumber } from "@/util"
import { investInProduct } from "@/api/investment"
import { getAllErrors } from "@/util"
import { useRouter } from "vuetify/lib/composables/router"

//piniastore
// const trn = useTransactStore()
const prd = useInvStore()
const route = useRoute()
const router = useRouter();
//const router = useRouter()

const isSidebarCollapsed = ref(false)
const drawerOpen = ref(false)
const isMobile = ref(false)


//Product type image
const defaultImage = avatarImage
const error = ref("")
const loading = ref(false)
//const agreed = ref(false)
const submitted = ref(false)
//const productId = ref("")
const slug = route.params.slug
const quantity = 1
const amount = ref(null)
// const descollapsed = ref(true)
const termCollapsed = ref(true)

const product = computed(() => prd.product || [])

const interestRate = computed(() => {
    return product.value?.interest || 0;
});

const minimumTenure = computed(() => {
    return product.value?.min_tenure || 30;
});

//const feeRateValue = ref(0.02); 
const feeRateValue = computed(() => {
    return product.value?.tr_fee || '';
});

const feeCap = computed(() => {
    return product.value?.tr_fee_cap || 2000;
});

const tax = computed(() => {
    return product.value?.tax || 10;
});

const taxAmount = computed(() => {
    return interestAccrued.value * (tax.value/100)
})


//capped
const transactionFee = computed(() => {
    const val = Number(amount.value)

    if (!val) return 0

    // convert percentage to decimal
    const rate = Number(feeRateValue.value) / 100

    // calculate fee
    const fee = val * rate

    // apply cap
    return Math.min(fee, feeCap.value)
})

const totalPay = computed(() => {
    const val = Number(amount.value);
    return val + transactionFee.value;
});

// const tax = computed(() => {});

//daily interest rate
const percentDailyRate = computed(() => {
    return (interestRate.value / 100) / 365;
});

//daily eaarnning
const dailyRate = computed(() => {
    const val = Number(amount.value);
    if (!val) return 0;

    const rate = val * percentDailyRate.value;
    return Number(rate.toFixed(2))
})

const tenureDays = computed(() => {
    if (!product.value?.maturity_date) return 0

    const today = new Date()
    const maturity = new Date(product.value.maturity_date)

    const diffDays = Math.ceil((maturity - today) / (1000 * 60 * 60 * 24))

    return diffDays
})

const interestAccrued = computed(() => { 
    const val = Number(amount.value);
    const interest = val * (interestRate.value / 100) * (tenureDays.value/365)
    return Number(interest.toFixed(2))
    //return dailyRate.value * minimumTenure.value
})
 
//total interest
const interestToPay = computed(() => {
   const interest = interestAccrued.value - taxAmount.value
   return Number(interest.toFixed(2))

})

//expected payout
const expectedPayout = computed(() => {
    const val = Number(amount.value);
    if (!val) return 0;

    // return val * Math.pow(
    //     (1 + percentDailyRate.value),
    //     minimumTenure.value
    // );
    const payout = val + interestToPay.value
    return Number(payout.toFixed(2))
});



//summary of investment
const showSummary = computed(() => {
    return Number(amount.value) >= 10000;
});

const form = reactive({
    agree: false
})

const touched = reactive({
    agree: false
})

const toggleAgree = () => {
    form.agree = !form.agree
    touched.agree = true
}

/* Mobile */
const toggleSidebar = () => {
    if (isMobile.value) drawerOpen.value = !drawerOpen.value
    else isSidebarCollapsed.value = !isSidebarCollapsed.value
}

const checkMobile = () => {
    isMobile.value = window.innerWidth < 768
    drawerOpen.value = !isMobile.value
}

const daysToMaturity = computed(() => {
    if (!product.value?.maturity_date) return 0

    const today = new Date()
    const maturity = new Date(product.value.maturity_date)

    const diffDays = Math.ceil((maturity - today) / (1000 * 60 * 60 * 24))

    //return diffDays > 0 ? diffDays : 'Matured'
    if (diffDays > 0) {
        return `Matures in ${diffDays} day${diffDays > 1 ? 's' : ''}`
    }

    return 'Matured'

})

//Snack bar
const snackbar = ref({
    show: false,
    message: "",
    color: "success" // success | error | warning | info
})

const showSnackbar = (message, color = "success") => {
    snackbar.value.message = message
    snackbar.value.color = color
    snackbar.value.show = true
}


const handleInvest = async () => {
    submitted.value = true

    // stop if not agreed
    //if (!agreed.value) return

    error.value = ""
    loading.value = true
    try {
        const res = await investInProduct({
            product_id: product.value.product_id,
            quantity: quantity,
            price: amount.value
        })
        //console.log(res.data.success)

        // SUCCESS MESSAGE
        if (res.data.success === true) {
            showSnackbar("You have successfully invested", "success")
        } else {
            showSnackbar(
                res.data.message,
                "error"
            )
        }

        setTimeout(() => {
            router.push({ name: "Portfolio" })
        }, 1000)
        //localStorage.setItem("token", res.data.data.token)
        //router.push("/add-username")
    } catch (e) {
        const msg = getAllErrors(e)
        //console.log(e.response?.data)
        showSnackbar(
            msg || "Signup failed",
            "error"
        )
    } finally {
        loading.value = false
    }
}


/* Lifecycle */
onMounted(async () => {
    checkMobile()
    window.addEventListener("resize", checkMobile)
    await prd.showProduct(slug)
    console.log(minimumTenure.value)
})

watch(
    async () => {
    await prd.showProduct(slug)
  }
)

onUnmounted(() => {
    window.removeEventListener("resize", checkMobile)
})
const tooltipText = {
    growth: "Total growth = (returns / investment) * 100",
    final_interest: "Your profit to be paid after tax",
    investment: "Total amount to be deducted from your wallet or bank for investing in this product",
    returns: "Total you will be paid after the invetment tenure elapse, which is interest plus principal",
    tax_on_interest: "Withoilding Tax (WHT) which is the Tax amount to be deducted from the interest"
}

</script>

<style scoped>
.main {
    display: flex;
    min-height: 100vh;
}

.main-content {
    flex: 1;
    background: #f8fafc;
}

.content {
    padding-left: 10%;
    padding-right: 10%;
}

/* Card */
.table-card {
    padding: 20px;
    border-radius: 14px;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.05);
}

.modern-input {
    width: 600px;
    height: 46px;
    margin-top: 6px;
    padding: 10px 14px;
    border-radius: 10px;
    border: 1px solid #d1d5db;
    font-size: 15px;
    background: #fff;
    transition: all 0.2s ease;
}

/* Header */
.table-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

/* Table */
.modern-table {
    border: none;
}

/* Product */
.product-cell {
    display: flex;
    align-items: center;
    gap: 12px;
}

.product-image {
    width: 40px;
    height: 40px;
    border-radius: 8px;
    object-fit: cover;
}

.product-image {
    width: 40px;
    height: 40px;
    border-radius: 8px;
    object-fit: cover;
    margin-right: 2%;
}

.product-name {
    font-weight: 700;
}

.product-desc {
    font-size: 16px;
    color: #64748b;
    text-align: left;
    padding: 0 12px;
    white-space: normal;
    overflow-wrap: break-word;
    word-break: break-word;
}

.product-desc p,
.product-desc div,
.product-desc span {
  max-width: 100%;
}

/* Button */
.theme-button {
    height: 46px;
    width: 100%;
    background: #0f2638;
    color: #fff;
    border-radius: 6px;
    font-weight: 600;
    transition: all 0.25s ease;
}

.theme-button:hover {
    background: #292828;
}

.theme-button:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}

/**IOS toggle */
.ios-toggle {
    width: 44px;
    height: 24px;
    background-color: #ccc;
    border-radius: 999px;
    position: relative;
    transition: background-color 0.3s ease;
    border: none;
    cursor: pointer;
}

.ios-toggle.active {
    background-color: #22c55e;
    /* green */
}

.ios-toggle-knob {
    width: 18px;
    height: 18px;
    background: #fff;
    border-radius: 50%;
    position: absolute;
    top: 3px;
    left: 3px;
    transition: transform 0.3s ease;
}

.ios-toggle.active .ios-toggle-knob {
    transform: translateX(20px);
}


/* Column title */
.column-title h5 {
    font-size: 1.1rem;
    font-weight: 400;
    margin-bottom: 2.5%;
}

/* Horizontal line below title */
.title-separator {
    border: none;
    height: 1px;
    background-color: #eae5e5;
    margin: 0;
    margin-bottom: 8px;
}

.product-card {
    border: 1px solid #e0e0e0;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
}

/* Outer card wrapping the 4 inner cards */
.outer-card {
    border: 1px solid #e4dede;
    border-radius: 8px;
    background: #fff;
    /* height: 100%; */
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 16px;
}

/* Inner cards */
.inner-card {
    border: 1px solid #eae5e5;
    border-radius: 6px;
    padding: 8px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
}

.inner-mini-card {
    border: 1px solid #f0f0f0;
    border-radius: 8px;
    background: #fafafa;
}

.fill-height {
    height: 100%;
}

.spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}


/* Mobile */
@media (max-width: 900px) {
    .content {
        padding: 0;
    }

    .avatar-mobile {
        width: 32px;
        height: 32px;
    }

    .title-mobile {
        font-size: 0.9rem;
    }

    .icon-mobile {
        font-size: 16px;
    }

    .modern-input {
        width: 100%;

    }
}
</style>
